import { render } from "./tests.vue?vue&type=template&id=71f15690&scoped=true"
import script from "./tests.ts?vue&type=script&lang=js"
export * from "./tests.ts?vue&type=script&lang=js"

import "./tests.vue?vue&type=style&index=0&id=71f15690&lang=scss&scoped=true"

import exportComponent from "I:\\Dev\\Projects\\LabManagement\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f15690"]])

export default __exports__